<template>
  <ActivityFrame :type="isInfoDisplayed">
    <template
      v-if="isLoadingCompleted"
      v-slot:content
    >
      <ActivityInfo v-show="isInfoDisplayed" />
      <Loading v-if="loading" />
      <!-- 是否完遊戲的popup -->
      <Popup
        v-if="touchPopup"
        @confirm="play"
        @cancel="touchPopup = false"
        @close="touchPopup = false"
      >
        <h5 class="alert-heading">
          {{ $t("activity.activity-popup-title") }}
        </h5>
        <p class="text-break-word font-size-md">
          {{ $t("activity.activity-popup-content") }}
        </p>
      </Popup>

      <!-- 遊戲中是否離開popup -->
      <Popup
        v-if="leavePopup"
        :have-cancel="false"
        @confirm="leavePopup = false"
        @close="leavePopup = false"
      >
        <h5 class="alert-heading" />
        <p class="text-break-word font-size-md">
          {{ $t("activity.activity-popup-content-ing") }}
        </p>
      </Popup>

      <!-- 獎勵發完popup -->
      <Popup
        v-if="noAwardPopup"
        :have-cancel="false"
        :have-close="false"
        @confirm="teset"
      >
        <h5 class="alert-heading">
          {{ $t("activity.activityaward-popup-title") }}
        </h5>
        <p class="text-break-word font-size-md">
          {{ $t("activity.activityaward-popup-content") }}
        </p>
      </Popup>
      <!-- 刮刮樂 start -->
      <ScratchOff
        v-if="activity.categoryID === 'Scratchoff'"
        v-show="!isInfoDisplayed"
        :mask-image="EventData.maskSource"
        :award-image="awardImage"
        :is-play="isPlay"
        @done="finishScratchOff"
        @show="touchPopup = true"
      />
      <!-- 刮刮樂 end -->

      <!-- 拉霸 start -->
      <Slots
        v-else-if="activity.categoryID === 'Slot'"
        v-show="!isInfoDisplayed"
        :color-type="EventData.colorType"
        :color="EventData.color"
        :button-wording="EventData.buttonWording"
        :button-color="EventData.buttonColor"
        :bg-display-img="EventData.bgDisplayImg"
        :activityconfirmpopup="activityconfirmpopup"
        :is-play="isPlay"
        :item="item"
        :itemlist="EventData.prizelist"
        @done="finishScratchOff"
        @show="touchPopup = true"
      />
      <!-- 拉霸 end -->

      <!-- 輪盤 start -->
      <Roulette
        v-else-if="activity.categoryID === 'Roulette'"
        v-show="!isInfoDisplayed"
        :color="EventData.color"
        :button-wording="EventData.buttonWording"
        :button-color="EventData.buttonColor"
        :itemlist="EventData.prizelist"
        :award-image="item.itemInfo.image"
        :bg-display-img="EventData.bgDisplayImg"
        :activityconfirmpopup="activityconfirmpopup"
        :item="item"
        :is-play="isPlay"
        @done="finishScratchOff"
        @show="touchPopup = true"
      />
      <!-- 輪盤 end -->

      <!-- 行動呼籲 start -->
      <CTAButton
        v-show="!isInfoDisplayed"
        :info="entertainmentInfo"
      />
      <!-- 行動呼籲 end -->

      <div
        class="my-2 d-flex flex-column"
        @click="isInfoDisplayed = !isInfoDisplayed"
      >
        <span
          class="material-icons"
          :style="`color: rgba(${isInfoDisplayed ? (EventData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255') : EventData.titleColor}, 1.0);`"
        >
          {{ isInfoDisplayed ? "keyboard_arrow_down" : "keyboard_arrow_up" }}
        </span>
        <h6
          :class="[isInfoDisplayed ? 'd-none' : 'd-flex']"
          class="justify-content-center"
          :style="`color: rgba(${EventData.titleColor}, 1.0);`"
        >
          <span>{{ $t("activity.activity-rules") }}</span>
        </h6>
      </div>

      <LotteryResult
        v-if="isAwardPopupVisible"
        :award-type="awardType"
        :item="item"
        :activity="activity"
        @confirm="isAwardPopupVisible = false"
      />
    </template>
  </ActivityFrame>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ActivityFrame from '@/components/activity/ActivityFrame.vue';
import ActivityInfo from '@/components/activity/ActivityInfo.vue';
import LotteryResult from '@/views/LotteryResult.vue';
import CTAButton from '@/components/activity/CTAButton.vue';
import ScratchOff from '@/components/entertainment/ScratchOff.vue';
import Slots from '@/components/entertainment/SlotsCanvas.vue';
import Roulette from '@/components/entertainment/RouletteCanvas.vue';
import pmtService from '@/services/pmtService';
import pageSettingGetter from '@/utils/pageSettingGetter';
import store from '@/store/index';
import Popup from '@/components/Popup.vue';
import Loading from '@/components/Loading.vue';
import { callbackRedirect } from '@/route/activity';
import i18n from '@/locales/i18n';

export default {
  components: {
    ActivityFrame,
    ActivityInfo,
    CTAButton,
    ScratchOff,
    Slots,
    Roulette,
    LotteryResult,
    Popup,
    Loading,
  },
  data() {
    return {
      // 活動資料
      activity: { scratchOffInfo: {}, slotInfo: {}, rouletteInfo: {} },
      EventData: {
        titleColor: '',
        maskSource: '',
        colorType: 1,
        buttonWording: '',
        buttonColor: '',
        bgDisplayImg: '',
        color: '',
        prizelist: [],
        transparentMask: '',
      },
      // 中獎商品資料
      item: { itemInfo: {} },
      // ACT參數
      parameters: [],
      // 是否顯示活動辦法
      isInfoDisplayed: false,
      // 是否要顯示獎品
      isAwardPopupVisible: false,
      // 是否缺少獎品
      isAwardLacking: false,
      // 中獎且得到獎品的通知文案
      winningAwardNoticeWording: '',
      // 中獎但未得到獎品的popup文案
      winningAwardButLackPopupWording: '',
      // Edenred中獎通知文案
      WinningGetEdenredNoticeWording: '',
      WinningGetCustomizeItemNoticeWording: '',
      WinningGetCustomizeItemNoticeNoFormWording: '',
      /**
       * 獎品分類，用作區分提示類型
       * 0. 預設值
       * 1. 一般獎品(包含未中獎)
       * 2. line point
       * 3. Edenred
       * 4. 活動獎項庫存不足
       */
      awardType: 0,
      isLoadingCompleted: false,
      touchPopup: false,
      isPlay: false,
      /* eslint-disable-next-line global-require */
      awardImage: require('@/assets/images/space.jpg'),
      loading: false,
      isPlaying: false,
      leavePopup: false,
      noAwardPopup: false,
      activityconfirmpopup: undefined,
      canShare: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.companyId || !to.params.memberSourceId || !to.params.activityId || !to.params.eventId || !to.params.activityResultId) {
      next({
        name: 'Error',
        params: { content: i18n.t('error.url-invalid') },
      });
    } else {
    // 前往活動錯誤頁函數
      const goToErrorPage = () => {
        next({
          name: 'Error',
          params: { content: i18n.t('error.activity-not-found') },
        });
      };

      store.commit('set', { name: 'companyId', value: to.params.companyId });
      store.commit('set', {
        name: 'memberSourceId',
        value: to.params.memberSourceId,
      });
      store.commit('set', { name: 'activityId', value: to.params.activityId });
      store.commit('set', { name: 'eventId', value: to.params.eventId });
      store.commit('set', { name: 'memberSourceId', value: to.params.memberSourceId });
      // 取得活動資料
      store.dispatch('getActivity').then((activity) => {
        // 回到活動首頁
        const goToFrontPage = () => {
          next({
            name: activity.isShareFullURL ? 'FrontPage' : 'FrontPageFake',
            params: {
              eventId: to.params.eventId,
              companyId: to.params.companyId,
              memberSourceId: to.params.memberSourceId,
              activityId: to.params.activityId,
            },
          });
        };
        // 沒有會員Id或token
        if (!store.state.memberId || !store.state.accessToken) {
          goToFrontPage();
          return;
        }

        // 作是否抽取過的判斷，已抽過進其它結果頁
        store.dispatch('getActivityResult', activity.no).then((results) => {
          if (results === null) {
            goToErrorPage();
          } else if (results.length > 0 && results[0].complete) {
            next({ name: activity.isShareFullURL ? 'EndPage' : 'EndPageFake', params: to.params });
          } else {
            next();
          }
        });
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // 上一步的判斷，如為callback，前往首頁
    if (!this.isPlaying) {
      callbackRedirect(to, from, next, this.canShare);
    } else {
      this.leavePopup = true;
      next(false);
    }
  },
  computed: {
    ...mapGetters(['hasForm']),
    // 娛樂活動資料(刮刮樂...)
    entertainmentInfo() {
      const vm = this;
      switch (vm.activity.categoryID) {
        // 刮刮樂
        case 'Scratchoff':
          return vm.activity.scratchOffInfo;
        // 拉霸
        case 'Slot':
          return vm.activity.slotInfo;
        // 輪盤
        case 'Roulette':
          return vm.activity.rouletteInfo;
        default:
          return {};
      }
    },
  },
  created() {
    const vm = this;
    window.addEventListener('beforeunload', (e) => {
      if (vm.isPlaying) { (e || window.event).returnValue = ''; }
    }, false);
    // 2021.05.12
    // 不知為何  window.location.href 到這裡時，網址的資料都會不見，只剩domain
    // 但在beforeRouteEnter的最後一行都是正常的
    // 正常的：http://192.168.11.37:8080/eventid/9879C8D4-2CC5-4CBA-A311-77575425BF0E/c21dd1aa-1d4c-11ea-b764-42010a8c001a/6babf5a9-4a2e-4f79-8fbf-bcac42b0b518
    // 到這麼會變成 http://192.168.11.37:8080/
    // 造成錯誤如下
    // 1.發送中獎通知 sendNotification() 用window.location.href只有網域，沒有完整參數
    // 2.MemberCenter 會因為window.location.href不完整導致無法正常連結
    // 錯誤原因不明
    // 解法：先改sendNotification內的資料，改用組的，不要用window.location.href

    // 取得活動資料
    const getActivity = vm.$store.dispatch('getActivity').then((activity) => {
      vm.activity = activity;
      vm.canShare = activity ? activity.isShareFullURL : true;
      switch (activity.categoryID) {
        case 'Scratchoff':
          vm.EventData.titleColor = activity.scratchOffInfo.titleColor;
          vm.EventData.maskSource = activity.scratchOffInfo.maskSource;
          vm.EventData.transparentMask = activity.scratchOffInfo.transparentMask;
          break;
        case 'Slot':
          vm.EventData.titleColor = activity.slotInfo.titleColor;
          vm.EventData.colorType = activity.slotInfo.colorType;
          vm.EventData.color = activity.slotInfo.color;
          vm.EventData.buttonWording = activity.slotInfo.buttonWording;
          vm.EventData.buttonColor = activity.slotInfo.buttonColor;
          vm.EventData.bgDisplayImg = activity.slotInfo.bgDisplayImg;
          vm.EventData.prizelist = activity.item;
          vm.EventData.transparentMask = activity.slotInfo.transparentMask;
          break;
        case 'Roulette':
          vm.EventData.titleColor = activity.rouletteInfo.titleColor;
          vm.EventData.color = activity.rouletteInfo.color;
          vm.EventData.buttonWording = activity.rouletteInfo.buttonWording;
          vm.EventData.buttonColor = activity.rouletteInfo.buttonColor;
          vm.EventData.bgDisplayImg = activity.rouletteInfo.bgDisplayImg;
          vm.EventData.prizelist = activity.item;
          vm.EventData.transparentMask = activity.rouletteInfo.transparentMask;
          break;
        default:
          break;
      }
    });
    // 取得頁面設定
    const getPageSetting = vm.$store
      .dispatch('sso/getPageSetting', 'Activity')
      .then((setting) => {
        vm.winningAwardNoticeWording = pageSettingGetter.getFunctionWording(
          setting,
          'WinningGetAwardNoticeWording',
        );
        vm.winningAwardButLackPopupWording = pageSettingGetter.getFunctionWording(
          setting,
          'WinningNotGetAwardPopupWording',
        );
        vm.WinningGetEdenredNoticeWording = pageSettingGetter.getFunctionWording(
          setting,
          'WinningGetEdenredNoticeWording',
        );
        vm.WinningGetCustomizeItemNoticeWording = pageSettingGetter.getFunctionWording(
          setting,
          'WinningGetCustomizeItemNoticeWording',
        );
        vm.WinningGetCustomizeItemNoticeNoFormWording = pageSettingGetter.getFunctionWording(
          setting,
          'WinningGetCustomizeItemNoticeNoFormWording',
        );
      });

    // 取得ACT參數
    const getAllParameter = vm.$store
      .dispatch('getAllParameter')
      .then((parameters) => {
        vm.parameters = parameters;
      });

    // 取得membersourcesetting
    const getMemberSourceSetting = vm.$store.dispatch('sso/getMemberSourceSetting').then((r) => {
      if (r.data[0].setttingDetl.find((x) => x.paramCode.toLowerCase() === 'activityconfirmpopup').paramValue === 'false') {
        this.play();
      } else {
        this.activityconfirmpopup = true;
      }
    });

    Promise.all([
      getActivity,
      getPageSetting,
      // updateActivityResult,
      getAllParameter,
      getMemberSourceSetting,
    ]).then(() => {
      vm.isLoadingCompleted = true;
    });
  },
  methods: {
    ...mapMutations(['set', 'setAwardInformation']),
    teset() {
      const vm = this;
      this.noAwardPopup = false;
      const { params } = vm.$route;
      // 清除活動資料，讓頁面重取
      vm.$store.commit('delete', { name: 'activity' });
      // 導頁到活動頁
      vm.$router.push({ name: this.canShare ? 'FrontPage' : 'FrontPageFake', params });
    },
    // 刮刮樂結束
    finishScratchOff() {
      const vm = this;
      vm.isPlaying = false;
      // 開啟獎品頁面
      if (!vm.isAwardLacking) {
        vm.isAwardPopupVisible = true;
      } else {
        vm.$popup.alert(vm.winningAwardButLackPopupWording);
      }
    },
    // 更新Edenred優惠卷發送時間
    putEdenredSendTime() {
      // 目前沒有不登入的狀況
      const vm = this;
      const { companyId, memberId } = vm.$store.state;
      const body = {
        companyId,
        isMember: vm.activity.isLogin,
        identity: memberId,
        edenredSerialNo: [vm.item.itemInfo.edenred[0].serialNo],
      };
      vm.$subscribeTo(pmtService.putEdenredSendTime(body));
    },
    // 取得URL中的檔案名稱
    getFileNameFromUrl(url) {
      // eslint-disable-next-line newline-per-chained-call
      return url.split('#').shift().split('?').shift().split('/').pop();
    },
    play() {
      this.isPlaying = true;
      this.touchPopup = false;
      const vm = this;
      vm.loading = true;
      // 更新活動結果資料
      const updateActivityResult = vm.$store
        .dispatch('updateActivityResult')
        .then(
          (res) => {
            const { data, status } = res;
            [vm.item] = data;
            vm.isPlay = true;
            if (status === '733') {
              // 活動獎項庫存不足 awardType = 4
              vm.awardType = 4;
            } else if (
            // line point獎項
              vm.item.itemInfo.linePoint
              && vm.item.itemInfo.linePoint.length > 0
            ) {
              vm.awardType = 2;
            } else if (
              vm.item.itemInfo.edenred
              && vm.item.itemInfo.edenred.length > 0
            ) {
              // edenred獎項
              vm.awardType = 3;
            } else if (
              vm.item.itemInfo.coupon
              && vm.item.itemInfo.coupon.length > 0
            ) {
              // coupon獎項
              vm.awardType = 5;
            } else {
              this.set({ name: 'prizeTitle', value: this.item.itemInfo.name });
              this.setAwardInformation({
                name: 'isAddress',
                value: this.item.itemInfo.isAddress,
              });
              this.setAwardInformation({
                name: 'isEmail',
                value: this.item.itemInfo.isEmail,
              });
              this.setAwardInformation({
                name: 'isIdentityNumber',
                value: this.item.itemInfo.isIdentityNumber,
              });
              this.setAwardInformation({
                name: 'isMobile',
                value: this.item.itemInfo.isMobile,
              });
              this.setAwardInformation({
                name: 'isName',
                value: this.item.itemInfo.isName,
              });
              this.setAwardInformation({
                name: 'isFillin',
                value: this.item.itemInfo.isFillin,
              });
              this.set({ name: 'isReceivingFormComplete', value: false });
              // 自訂
              vm.awardType = 1;
            }
          },
          (e) => {
          // API回傳失敗，回到活動首頁
            vm.isPlaying = false;
            if (e.data.status !== '731') {
              const { params } = vm.$route;
              // 清除活動資料，讓頁面重取
              vm.$store.commit('delete', { name: 'activity' });
              // 導頁到活動頁
              vm.$router.push({ name: this.canShare ? 'FrontPage' : 'FrontPageFake', params });
            } else {
              this.noAwardPopup = true;
            }
          },
        );

      Promise.all([
        updateActivityResult,
      ]).then(() => {
        if (vm.activity.categoryID === 'Scratchoff') {
          vm.isLoadingCompleted = false;
          vm.awardImage = vm.item.itemInfo.image;
          // 需要一點時間換中獎圖片
          setTimeout(() => {
            vm.isLoadingCompleted = true;
            vm.loading = false;
          }, 100);
        } else {
          vm.loading = false;
        }
      });
    },
  },
};
</script>
